import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationGaData } from './Data';

export interface IntegrationGaFlowPageEventState {
  flowPageId: number;
  action?: string;
  category?: string;
  label?: string;
  value?: string;
}

export enum IntegrationGaType {
  UA_KEY,
  NO_UA_KEY
}

export interface IntegrationGAState extends BaseIntegrationState {
  type?: IntegrationGaType;
  uaKey?: string;
  events: IntegrationGaFlowPageEventState[];
}

export class IntegrationGaModel extends BaseIntegration<IntegrationGaData, IntegrationGAState> {
  parse(data: IntegrationGaData) {
    super.parse(data);

    let type: IntegrationGaType | undefined;

    switch (data.settings?.type) {
      case '2':
        type = IntegrationGaType.UA_KEY;
        break;
      case '3':
        type = IntegrationGaType.NO_UA_KEY;
        break;
    }

    this.state.type = type;
    this.state.uaKey = data.settings?.ua_key;

    const events: IntegrationGaFlowPageEventState[] = [];

    if (data.settings?.sections) {
      for (const section in data.settings?.sections) {
        const sectionId = Number(section);

        if (
          Object.prototype.hasOwnProperty.call(data.settings.sections, section) &&
          // eslint-disable-next-line security/detect-object-injection
          data.settings.sections[sectionId].ga_event_enable === '1'
        ) {
          events.push({
            flowPageId: sectionId,
            // eslint-disable-next-line security/detect-object-injection
            action: data.settings.sections[sectionId].ga_event_action || undefined,
            // eslint-disable-next-line security/detect-object-injection
            category: data.settings.sections[sectionId].ga_event_category || undefined,
            // eslint-disable-next-line security/detect-object-injection
            label: data.settings.sections[sectionId].ga_event_label || undefined,
            // eslint-disable-next-line security/detect-object-injection
            value: data.settings.sections[sectionId].ga_event_value || undefined
          });
        }
      }
    }

    this.state.events = events;
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/ga/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Istvan Bovan / Dannie Hansen';
  }
}
